module.exports = __webpack_public_path__ + "img/Bear34.adf83394.jpg";